import React, { useCallback, useEffect, useRef, useState } from "react";
import { AgendaDocument, AgendaUserType, CreateAgendaDocumentByUserIdMutation, CreateAgendaDocumentByUserIdMutationVariables, DocsByUserQuery, DocsByUserQueryVariables, GetAgendaUserQuery, GetAgendaUserQueryVariables, ModelSortDirection, OnCreateAgendaDocumentByUserIdSubscription, OnCreateAgendaDocumentByUserIdSubscriptionVariables, UsersByComIdQuery, UsersByComIdQueryVariables } from "../../graphql/API";
import { createAgendaDocumentByUserId, docsByUser, getAgendaUser, onCreateAgendaDocumentByUserId, usersByComId } from "./queries";
import { useLazyQuery, useMutation, useQuery, useSubscription } from "@apollo/client";
import { useAuthContext } from "../../contexts/AuthContext";
import Document from '../../components/Document';
import { v4 as uuidV4 } from 'uuid';
import { getUrl, remove, uploadData } from 'aws-amplify/storage';
import useNotificationStorageService from "../services/NotificationStorageService";
import { useNotification } from "../../contexts/NotificationProvider";
import SubscriptionDocumentWrapper from "./subscriptionWrappers/subscriptionDocumentWrapper";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Button, Col, Modal, Row, Spinner } from "react-bootstrap";
import Sidebar from "../services/Sidebar/Sidebar";
import { IoArrowRedoCircleOutline, IoDocumentAttach } from "react-icons/io5";
import { FaUsers } from "react-icons/fa6";
import { getAgendaDocument } from "../../graphql/queries";
import { DOCUMENTS_PER_PAGE } from "../../config";
import TopicNotificationService from "../services/TopicService";
import CustomModal from "../../components/Modals/CustomModal";


const DocumentByWorkerScreen = () => {
    // AUTH
    const {userId: AuthUserId} = useAuthContext();
    // PARAMS
    const { id } = useParams<{ id: string }>();
    // I18N
    const { t } = useTranslation();
    const [locale, setLocale] = useState("en");
    // DOCUMENTS
    const [newDocuments, setNewDocuments] = useState<AgendaDocument[]>([]);
    const [documents, setDocuments] = useState<AgendaDocument[]>([]);
    const [nextToken, setNextToken] = useState('');
    const [isFetchingMore, setIsFetchingMore] = useState(false);
    const isRefreshingRef = useRef(false);
    const [file, setFile] = useState<any>(null);
    // NAVIGATION
    const navigate = useNavigate();
    const location = useLocation();
    // SUBSCRIPTION
    const [subscriptionKey, setSubscriptionKey] = useState(0);
    // NOTIFICATION
    // const {sendDocumentNotification} = DocumentNotificationService();
    const {sendTopicNotification} = TopicNotificationService();
    const notificationContext = useNotification();
    const notificationCount = notificationContext?.notificationCount;
    const setNotificationCount = notificationContext?.setNotificationCount;
    const documentCount = notificationContext?.documentCount;
    const setDocumentCount = notificationContext?.setDocumentCount;
    const {updateNotificationModelCount} = useNotificationStorageService(); 
    // LOADING & FILE
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [uploadStatus, setUploadStatus] = useState<string | null>(null);
    // MODAL
    const [contentModal, setContentModal] = useState(null);
    const [linkModal, setLinkModal] = useState(null);
    const [showCustomModal, setShowCustomModal] = useState(false);
    const [footerModal, setFooterModal] = useState(true);

    const {data, loading, error, refetch} = 
        useQuery<GetAgendaUserQuery, GetAgendaUserQueryVariables>(getAgendaUser, 
            {variables: {userId: AuthUserId}});

    const {data: dataUser, loading: loadingUser, error: errorUser, refetch: refetchUser} = 
        useQuery<GetAgendaUserQuery, GetAgendaUserQueryVariables>(getAgendaUser, 
            {variables: {userId: id}});

    const {data: dataDocument, loading: loadingDocument, error: errorDocument, 
        refetch: refetchDocumentData, fetchMore: fetchMoreDocument} = 
        useQuery<DocsByUserQuery, DocsByUserQueryVariables >(docsByUser
        ,{variables: {userId: id, sortDirection: ModelSortDirection.DESC, 
            limit: DOCUMENTS_PER_PAGE, filter: {deleted: {ne: true}}}});

    const [fetchManagers, {data: dataManagers, loading: loadingManagers, error: errorManagers, 
        refetch: refetchManagersData, fetchMore: fetchMoreManagers}] = 
        useLazyQuery<UsersByComIdQuery, UsersByComIdQueryVariables >(usersByComId);

    const [doCreateDocument] = useMutation<CreateAgendaDocumentByUserIdMutation, CreateAgendaDocumentByUserIdMutationVariables>(createAgendaDocumentByUserId);

    const self = data?.getAgendaUser;
    const user = dataUser?.getAgendaUser;

    // const documents = (dataDocument?.docsByUser?.items || []);
    // const nextToken = dataDocument?.docsByUser?.nextToken; 
    useEffect(() => {
        if (!self) return;
        if (!self.language || !self.comId) return;
        setLocale(self?.language);
        fetchManagers({variables: {
            comId: self?.comId, 
            sortDirection: ModelSortDirection.DESC, 
            // limit: 10, 
            filter: {
                suspended: {ne: true},
                type: {eq: "MANAGER" as AgendaUserType}
            }}});
    }, [self]);

    const managers = dataManagers?.usersByComId?.items;

    useEffect(() => {
      setNotificationCount && setNotificationCount((notificationCount ?? 0) - (documentCount ?? 0));
      updateNotificationModelCount('document', 0);
      setDocumentCount && setDocumentCount(0);
    }, [location]);

    const applyOnDocument = () => {
      return
        // Alert.alert("Adding a document", "Are you sure you want to add a document?", [
        //     { text: "Cancel", style: 'cancel',},
        //     { text: "Upload", style: 'destructive', onPress: uploadMedia, },]
        // );
    };

    // useEffect(() => {
    //     if (file) {
    //         applyOnDocument();
    //     };
    // }), [file];

    useEffect(() => {
        setDocuments((dataDocument?.docsByUser?.items?.filter((item): item is AgendaDocument => item !== null) || []));
        setNextToken(dataDocument?.docsByUser?.nextToken || '');
    }, [dataDocument]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setNewDocuments([]);
        }, 1000 * 60 * 5); // 5 minutes
        
        return () => clearTimeout(timer);
    }, [newDocuments]);

    const loadMore = async () => {
      if (!nextToken || (nextToken == '') || isFetchingMore) {
          return;
      };
      setIsFetchingMore(true);
      const { data: moreData } = await fetchMoreDocument({ variables: { nextToken },
          // variables: { nextToken },
          updateQuery: (previousQueryResult: any, { fetchMoreResult }: any) => {
            if (!fetchMoreResult) return previousQueryResult;
      
            // Met à jour l'état de posts pour y inclure les nouveaux articles
            setDocuments(prevPosts => [
              ...prevPosts,
              ...fetchMoreResult.docsByUser.items,
            ]);

            setNextToken(fetchMoreResult.docsByUser.nextToken);
      
            return {
              ...previousQueryResult,
              docsByUser: {
                ...previousQueryResult.docsByUser,
                items: [
                  ...previousQueryResult.docsByUser.items,
                  ...fetchMoreResult.docsByUser.items,
                ],
                nextToken: fetchMoreResult.docsByUser.nextToken,
              },
            };
          },
      });
      setIsFetchingMore(false);
    };

    // PAGINATION
    useEffect(() => {
      const handleScroll = () => {
          const scrollable = document.documentElement.scrollHeight - window.innerHeight;
          const scrolled = window.scrollY;
          if (scrollable - scrolled < 5) {
              loadMore();
          }
      };
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
  }, [nextToken, isFetchingMore]);

  const refreshingPosts = () => {
      setNewDocuments([]);
      refetchDocumentData();
  };

  // REFRESH BY SCROLLING
  useEffect(() => {
      window.scrollTo(0, 5);

      const handleScrollTop = () => {
          if (window.scrollY < 3 && !isRefreshingRef.current) {
              // console.log('Refreshing posts...');
              isRefreshingRef.current = true;
              refreshingPosts();
              window.scrollTo(0, 5);

              setTimeout(() => {
                  isRefreshingRef.current = false;
              }, 2000);
          }
      };

      window.addEventListener("scroll", handleScrollTop);

      return () => {
          window.removeEventListener("scroll", handleScrollTop);
      };
  }, [loadingDocument]);

    const handleSubscriptionError = () => {
        console.warn("Subscription error, retrying in 5s...");
        setTimeout(() => {
          setSubscriptionKey((prev) => prev + 1);
        }, 5000);
    };

    // useEffect(() => {
    //     if (newDocumentData?.onCreateAgendaDocumentByUserId) {
    //         console.log('grr');
    //         // setNewDocuments((existingNewDocuments) => [newDocumentData.onCreateAgendaDocumentByUserId as AgendaDocument, ...existingNewDocuments])
    //     } else {
    //         // console.log('allo');
    //         // refetchDocumentData();
    //     };
    //     console.log('documentData', newDocumentData);
    // }, [newDocumentData]);

    if (!self || loadingDocument) {// || loadingShift || loadingRequest) {
        return (
          <div className="spinnerContainer">
              {/* <Spinner animation="border" role="status" style={styles.spinner as React.CSSProperties}> */}
              <Spinner animation="border" role="status" className="spinner">
                  <span className="visually-hidden">Loading...</span>
              </Spinner>   
          </div>
        )
    };
        
    // if (refetchDocument) {
    //     refetchDocument = false;
    //     // refetch();
    //     refetchDocumentData();
    // };

    const isNewDocument = (document: AgendaDocument) => {
        // console.log(newPosts.some(c => c.postId == post.postId));
        return newDocuments.some(c => c.docId == document.docId);
    };

    const refreshingDocuments = () => {
        setNewDocuments([]);
        refetchDocumentData();
    };

    const generateCustomId = () => {
      const prefix = "Document";
      const uniquePart = uuidV4();
      return `${prefix}-${uniquePart}`;
    };

    const createDocument = async (result: any, name: string, type: string, username: string, FCMtoken: string) => {
        console.log('result', result);
        try {
            const docId = generateCustomId();
            await doCreateDocument({
                variables: {
                    docId: docId,
                    comId: user?.comId,
                    userId: user.userId,
                    name: name,
                    path: result.key,
                    type: type,
                    deleted: false,
                    createdAt: new Date().toISOString(),
                    updatedAt: new Date().toISOString(),
                }
            });
            for (const manager of managers) { //managers?.forEach(manager => {
                // if (manager?.FCMtoken) {
                if (manager?.userId != user?.userId) {
                  // sendDocumentNotification(username ?? undefined, name ?? undefined, manager?.FCMtoken ?? undefined, manager?.userId ?? undefined, docId ?? undefined);
                  await sendTopicNotification(
                    username ?? undefined, 
                    name ?? undefined, 
                    manager?.FCMtoken ?? undefined, 
                    user?.userId ?? undefined, 
                    docId ?? undefined, 
                    null,
                    null,
                    "document",
                  );
                }
                // }
            };
            refetchDocumentData();
        } catch (error) {
            alert('Error creating your file: ' + (error as Error).message);
        }
    };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setFile(file)
      setSelectedFile(file);
      // console.log('Fichier sélectionné :', file);
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) return;
    // console.log('size', selectedFile.size);
    if (selectedFile.size > 5120000) {
      setContentModal(
        <>
          <Modal.Header closeButton>
            <Modal.Title>{
              t('document.sizeTitle')}
            </Modal.Title>
          </Modal.Header>
      
          <Modal.Body>
            <p>{t('document.sizeMessage')}</p>
          </Modal.Body>
        </>);
      setShowCustomModal(true);
      return
    }
    try {
      const fileName = `${uuidV4()}_${file.name}`;
      const uriParts = file.name.split('.');
      const extension = uriParts[uriParts.length - 1];
      const name = file.name;
      const type = file.type;
      const result = await uploadData({
        // key: fileName,//`${uuidV4()}.${extension}`,
        path: `private/${user?.comId}/${user?.userId}/documents/${fileName}`,
        // name: file.name,
        data: selectedFile,
      }).result;
      createDocument(result, fileName, type, user?.username ?? "undefined", user?.FCMtoken ?? "undefined");
    } catch (error: any) {
      console.error("Erreur lors de l'envoi du fichier:", error);
      setUploadStatus(`❌ Erreur : ${error.message}`);
    }
  };  

    const mergedDocuments = [...newDocuments, ...documents.filter(d => !newDocuments.some(n => (n.docId === d?.docId)))];
    // console.log(mergedDocuments);
  
    return (
      <>
        <CustomModal
          show={showCustomModal}
          onHide={() => setShowCustomModal(false)}
          link={linkModal}
          children={contentModal}
          isFooter={footerModal}
          // animation={true}
        />
        <div className="d-flex min-vh-100">
            <Sidebar user={self} />
            <div className="commentScreenContainer flex-grow-1 p-3">
                {loadingDocument && (
                    <div style={{ textAlign: 'center', marginBottom: 10 }}>
                        <Spinner animation="border" size="sm" />
                        <span> {t('Refreshing...')}</span>
                    </div>
                )}
                <div className="tabs">
                    { self.type === "MANAGER" ?
                    <Link to="/documents" className="document_row_link">
                      <div className="document_row">
                        <IoDocumentAttach  size={30} color={'#CCC'} />
                        <span className='textTab'>{t('navBar.myDocuments')}</span>
                      </div>
                    </Link>
                    :
                      <div className="document_row">
                        <IoDocumentAttach  size={30} color={'#CCC'} />
                        <span className='textTab'>Documents</span>
                      </div>
                    }
                </div>

                {user?.comId && (
                    <SubscriptionDocumentWrapper
                        key={subscriptionKey}
                        userId={user.userId}
                        subscriptionKey={subscriptionKey}
                        onNewDocument={(doc) => {
                            setNewDocuments((prev) => [doc, ...prev]);
                        }}
                        onError={handleSubscriptionError}
                    />
                )}
                {mergedDocuments.length === 0 && !loadingDocument ? (
                    <div style={{ textAlign: 'center', marginTop: '2rem' }}>
                        <p>{t('post.pleaseWriteComment')}</p>
                    </div>
                ) : (
                  mergedDocuments.map((item, index) =>
                    item ? (
                        <Document
                            key={item.docId || index}
                            document={item}
                            // {{
                            //     ...item,
                            //     user: (item as any)?.user || null,
                            // } as Idocument}
                            // Liked={true}
                            includedDetails={true}
                            isNew={isNewDocument(item)}
                            locale={locale}
                            // @ts-ignore
                            user={self}
                        />
                    ) : null
                    )
                )}
                { self && self.comId &&
                  <>
                  <div className="post_input_wrapper" >
                    <div className="post_input_container" >
                      <Row>
                        <Col xs={12} md={6}>
                          <input type="file" title={t('document.selectFile')} onChange={handleFileChange} className="form-control" />
                        </Col>
                        <Col xs={12} md={6} className="mt-2 mt-md-0">
                          <Button className="w-100" title={t('document.importFileBtn')} onClick={handleUpload} disabled={!selectedFile}>{t('document.importFileBtn')}</Button>
                        </Col>
                      </Row>
                    </div>
                  </div>
                  </>
                }
                {uploadStatus && <p>{uploadStatus}</p>}
            </div>
        </div>
      </>
    )
};

export default DocumentByWorkerScreen;